/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetLastSelectedIdParameter } from './ApiUserTasksGetLastSelectedIdParameter';
import {
    ApiUserTasksGetLastSelectedIdParameterFromJSON,
    ApiUserTasksGetLastSelectedIdParameterFromJSONTyped,
    ApiUserTasksGetLastSelectedIdParameterToJSON,
    ApiUserTasksGetLastSelectedIdParameterToJSONTyped,
} from './ApiUserTasksGetLastSelectedIdParameter';

/**
 * 
 * @export
 * @interface InvoiceActionResponse
 */
export interface InvoiceActionResponse {
    /**
     * 
     * @type {ApiUserTasksGetLastSelectedIdParameter}
     * @memberof InvoiceActionResponse
     */
    invoiceId: ApiUserTasksGetLastSelectedIdParameter;
    /**
     * 
     * @type {string}
     * @memberof InvoiceActionResponse
     */
    status: string;
}

/**
 * Check if a given object implements the InvoiceActionResponse interface.
 */
export function instanceOfInvoiceActionResponse(value: object): value is InvoiceActionResponse {
    if (!('invoiceId' in value) || value['invoiceId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function InvoiceActionResponseFromJSON(json: any): InvoiceActionResponse {
    return InvoiceActionResponseFromJSONTyped(json, false);
}

export function InvoiceActionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceActionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invoiceId': ApiUserTasksGetLastSelectedIdParameterFromJSON(json['invoiceId']),
        'status': json['status'],
    };
}

export function InvoiceActionResponseToJSON(json: any): InvoiceActionResponse {
    return InvoiceActionResponseToJSONTyped(json, false);
}

export function InvoiceActionResponseToJSONTyped(value?: InvoiceActionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoiceId': ApiUserTasksGetLastSelectedIdParameterToJSON(value['invoiceId']),
        'status': value['status'],
    };
}

